import type { HarmonyPackageBoardColumn } from '@rhythmic/db/types'
import * as z from 'zod'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const HARMONY_PACKAGE_BOARD_COLUMN_TABLE = '"public"."harmonyPackageBoardColumns"'

export const HarmonyPackageBoardColumnSchema = z.object({
  id: z.string().min(5, 'Column ID is required'),
  board_id: z.string().min(1, 'Board ID is required'),
  name: z.string().min(1, 'Column name is required'),
  position: z.number().min(0, 'Position must be a positive integer'),
  workspace_id: z.uuid('Workspace ID must be a valid UUID'),
  status_type: z.string(),
}) satisfies z.ZodType<HarmonyPackageBoardColumn>
export const HarmonyPackageBoardColumnsCreatePayloadSchema = HarmonyPackageBoardColumnSchema.omit({
  id: true,
})

export const HarmonyPackageBoardColumnConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_BOARD_COLUMN_TABLE,
  partitionKey: 'board_id',
  key: 'id',
  apiEndpoint: '/api/harmony-package-board-columns',
  where: {},
  schema: HarmonyPackageBoardColumnSchema,
}
